import CustomElement from '../core/custom.js'
import Emitter from '../core/emitter.js'
import Viewport from '../stores/viewport.js'
import getOffsetTop from '../utilities/getOffsetTop.js'
import { preload } from '../utilities/preload.js'

export default window.customElements.define(
  'resource-image',
  class extends CustomElement {
    isVertical = true
    constructor() {
      super()

      this._onResize = this.onResize.bind(this)
      this._onUpdate = this.onUpdate.bind(this)
    }

    connectedCallback() {
      super.connectedCallback()

      this.$img = this.querySelector('.js-img')

      if (!this.$img) {
        return console.warn(
          'BlockIndustries: This component must be have a .js-img child',
          this
        )
      }

      Emitter.on('resize', this._onResize)
      Emitter.on('update', this._onUpdate)

      this._onResize()
      preload(this.$img.currentSrc).then(this._onResize)

      this.onlyFromLg = this.dataset.from
    }

    disconnectedCallback() {
      super.disconnectedCallback()

      Emitter.off('resize', this._onResize)
      Emitter.off('update', this._onUpdate)
    }

    onResize() {
      this._offsetTop = getOffsetTop(this)
      this._height = this.offsetHeight
    }

    onBreakpoint({ viewport }) {
      this.toLg = viewport.to('lg')
    }

    onUpdate() {
      if (this.onlyFromLg && this.toLg) return

      if (!this.toLg) {
        if (window.scrollY < this._offsetTop - Viewport.height) {
          this._translateY = Viewport.height * 0.3
        } else if (
          window.scrollY >= this._offsetTop - Viewport.height &&
          window.scrollY < this._offsetTop
        ) {
          this._translateY = (this._offsetTop - window.scrollY) * 0.3
        } else if (
          window.scrollY >= this._offsetTop &&
          window.scrollY < this._offsetTop + this.offsetHeight - Viewport.height
        ) {
          this._translateY = 0
        } else if (
          window.scrollY >=
            this._offsetTop + this.offsetHeight - Viewport.height &&
          window.scrollY < this._offsetTop + this.offsetHeight
        ) {
          this._translateY =
            (this._offsetTop +
              this.offsetHeight -
              Viewport.height -
              window.scrollY) *
            0.3
        } else {
          this._translateY = -Viewport.height * 0.3
        }
      } else {
        if (window.scrollY > this.offsetHeight) {
          this._translateY = this.offsetHeight * 0.3
        } else {
          this._translateY = -window.scrollY * 0.3
        }
      }

      this.$img.style.transform = ` matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, ${-this
        ._translateY}, 0, 1)`
    }
  }
)
